import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js/instance/for-each";

const humanize = string => {
  const [[firstChar, ...rest], ...words] = string.split(/[\W\s]/g);
  const capitalizedFirstWord = [firstChar.toUpperCase(), ...rest].join('');
  return [capitalizedFirstWord, ...words].join(' ');
};

const normalizeFieldName = name => name ? humanize(name) : 'Field';

const createErrors = function (property, value) {
  let validators = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  const errors = [];

  _forEachInstanceProperty(validators).call(validators, validator => {
    const result = validator.validate(normalizeFieldName(property), value);

    if (result) {
      errors.push({
        name: validator.name,
        data: result
      });
    }

    errors[validator.name] = result;
  });

  return errors;
};

export default createErrors;